import { useMemo } from 'react';

import { DELIVERY_STATUS } from '~constants/delivery';

export const useRejectedOrder = (hasDelivery, deliveryStatus) => {
  const isRejected = useMemo(
    () =>
      hasDelivery &&
      (deliveryStatus === DELIVERY_STATUS.REJECTED ||
        deliveryStatus === DELIVERY_STATUS.CANCELLED ||
        deliveryStatus === DELIVERY_STATUS.EXPIRED),
    [deliveryStatus, hasDelivery]
  );

  return { isRejected };
};
